import { ArrowRight, CheckCircle, DeviceMobile, Storefront, Truck } from "@phosphor-icons/react";
import { useNavigate } from "react-router-dom";

export const OnboardingSection = () => {
  const navigate = useNavigate();

  const partnerCards = [
    {
      icon: Storefront,
      title: "Seller Portal",
      subtitle: "For material stores and construction suppliers",
      description: "List materials, manage product availability, receive order enquiries, and build your supplier presence through Loado.",
      color: "#FF5500",
      href: "/seller-portal",
      action: "Open Seller Portal",
      points: ["Chennai supplier onboarding", "Product listing support", "Order management flow"]
    },
    {
      icon: Truck,
      title: "Delivery Partners",
      subtitle: "For drivers, vehicle owners, and fleet operators",
      description: "Join Loado's construction logistics network and support material movement across active service areas.",
      color: "#0055FF",
      href: "/delivery-partner",
      action: "Join as Driver",
      points: ["Bike to truck categories", "App download support", "Chennai onboarding"]
    }
  ];

  return (
    <section
      id="onboarding"
      data-testid="onboarding-section"
      className="py-20 lg:py-32 bg-[#0F172A] relative overflow-hidden"
    >
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
        }}></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid lg:grid-cols-[0.8fr_1.2fr] gap-10 lg:gap-14 items-start">
          <div>
            <div className="inline-flex items-center gap-2 mb-5">
              <DeviceMobile size={20} weight="duotone" className="text-[#FF5500]" />
              <span className="text-xs font-semibold uppercase tracking-[0.2em] text-[#FF5500]">
                Partner With Loado
              </span>
            </div>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-white mb-5">
              One ecosystem for supply and movement.
            </h2>
            <p className="text-lg text-slate-400 leading-relaxed">
              We moved onboarding and support into dedicated pages so sellers and
              drivers get the right information before applying.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-6">
            {partnerCards.map((card) => (
              <div key={card.title} className="bg-white p-6 lg:p-8 rounded-lg relative overflow-hidden">
                <div className="absolute top-0 left-0 right-0 h-1" style={{ backgroundColor: card.color }}></div>
                <div className="w-12 h-12 flex items-center justify-center rounded-lg mb-5" style={{ backgroundColor: `${card.color}15` }}>
                  <card.icon size={28} weight="duotone" style={{ color: card.color }} />
                </div>
                <h3 className="text-xl font-bold text-[#0F172A] mb-1">{card.title}</h3>
                <p className="text-sm font-medium text-slate-500 mb-4">{card.subtitle}</p>
                <p className="text-sm text-slate-600 leading-relaxed mb-5">{card.description}</p>
                <div className="space-y-2 mb-6">
                  {card.points.map((point) => (
                    <div key={point} className="flex items-center gap-2 text-sm text-slate-600">
                      <CheckCircle size={16} weight="fill" style={{ color: card.color }} />
                      {point}
                    </div>
                  ))}
                </div>
                <button
                  onClick={() => navigate(card.href)}
                  className="group w-full inline-flex items-center justify-center gap-2 px-5 py-3 text-white font-semibold rounded-lg transition-colors"
                  style={{ backgroundColor: card.color }}
                >
                  {card.action}
                  <ArrowRight size={18} weight="bold" className="transition-transform group-hover:translate-x-1" />
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
